export default __webpack_public_path__ + "static/media/pricing-summary-hero.d166ddc8.png";